// extracted by mini-css-extract-plugin
export default {"food_listing_container":"Food-listing-fc_food_listing_container__7m2Ne"};